<template>
  <div class="print-results">
    <el-table class="table-striped wrap-whole-words" id="jobSearchResults"
              :data="tableData"
              border
              style="width: 100%">
      <el-table-column v-for="column in tableColumns"
                       :key="column.label"
                       :min-width="column.minWidth"
                       :prop="column.prop"
                       :sortable="column.sortable"
                       :label="column.label">
      </el-table-column>
      <el-table-column
                       key="targetCompletionDate"
                       min-width="210"
                       prop="targetCompletionDate"
                       sortable
                       label="Target Completion Date">
        <template slot-scope="props">
          {{ props.row._source.targetCompletionDate | formatDate }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { Table, TableColumn } from 'element-ui'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      Table,
      TableColumn
    },
    computed: {
      ...mapGetters({
        tableData: 'jobs/search/results'
      })
    },
    data() {
      return {
        tableColumns: [
          {
            prop: '_source.project.name',
            label: 'Project Name',
            minWidth: 140,
            sortable: true
          },
          {
            prop: '_source.name',
            label: 'Name',
            minWidth: 110,
            sortable: true
          },
          {
            prop: '_source.number',
            label: 'Number',
            minWidth: 110,
            sortable: true
          },
          {
            prop: '_source.coordinator',
            label: 'Type',
            minWidth: 100,
            sortable: true
          },
          {
            prop: '_source.priority',
            label: 'Priority',
            minWidth: 100,
            sortable: true
          },
          {
            prop: '_source.status',
            label: 'Status',
            minWidth: 100,
            sortable: true
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>
